import L10n from "lib/carrot-l10n"
import React, { FC } from "react"
import { RoundedRectangle } from "components/views/atoms/roundedrectangle/RoundedRectangle"
import { H3 } from "@carrotfertility/carotene"
import { ArrowLink } from "components/views/atoms/links/ArrowLink"
import { useToggle } from "utils/Hooks"
import { HowMuchReimbursedModalContainer } from "../../../containers/reimbursements/educationmodal/HowMuchReimbursedModalContainer"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const HowMuchReimbursedModule: FC = () => {
  const [showReimbursementModal, toggleShowReimbursementModal] = useToggle()

  return (
    <>
      <RoundedRectangle backgroundColor="light-gray">
        <H3 variant="primary" stack="tiny">
          {l(`How much will I be reimbursed?`)}
        </H3>
        <ArrowLink onClickOnly={true} onClick={toggleShowReimbursementModal}>{l`Get details`}</ArrowLink>
      </RoundedRectangle>
      {showReimbursementModal && <HowMuchReimbursedModalContainer onExit={toggleShowReimbursementModal} />}
    </>
  )
}

export { HowMuchReimbursedModule }
